<template>
    <applications-reject
        :params="{
            application: application.uuid
        }"
        v-slot="{
            sid,
            is_loading: is_saving,
            error,
            execute,
            forget
        }"
        @success="onSuccess"
    >
        <div>
            <error-modal
                v-if="error"
                :error="error"
                @close="forget"
            />

            <modal-success
                v-else-if="show_success_modal"
                :is-open="show_success_modal"
                @close="closeAll(); $emit('success')"
            >
                <template slot="heading">Application Closed!</template>

                <p>Application successfully closed.</p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="btn text-center"
                    >
                        Close
                    </button>
                </div>
            </modal-success>

            <modal-red
                v-else-if="show_form_modal"
                :is-open="show_form_modal"
                @close="closeAll"
            >
                <base-form
                    slot-scope="{ close }"
                    @submit="execute(form)"
                >
                    <div class="pt-4 pb-3 px-4 sm:p-6">
                        <h6 class="text-center font-semibold text-lg font-normal mb-3">
                            Reject/Close Application
                        </h6>

                        <div class="text-grey-darker">
                            <p class="mb-3">
                                Reject/close applications that you're done with. We'll let the applicants know that the
                                application has been closed.
                            </p>

                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="rejected_reason"
                            >
                                <template slot="label">Reason</template>

                                <input-select
                                    v-model="form.rejected_reason"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    :options="[
                                        { value: 'property-let', label: 'The property has already been let' },
                                    ]"
                                    name="rejected_reason"
                                />
                            </form-item>

                            <p><strong>You cannot undo this action.</strong></p>
                        </div>
                    </div>

                    <footer class="flex flex-col md:flex-row-reverse bg-grey-bg rounded-b py-3 px-6">
                        <base-button
                            :is-loading="is_saving"
                            type="submit"
                            class="btn btn-red w-full md:w-auto"
                        >
                            Reject Application
                        </base-button>

                        <button
                            type="button"
                            class="btn text-center md:mr-3"
                            @click.prevent="close"
                        >
                            Cancel
                        </button>
                    </footer>
                </base-form>
            </modal-red>
        </div>
    </applications-reject>
</template>

<script>
    import ApplicationsReject from '../../../../../../components/applications-reject'

    export default {
        components: {
            ApplicationsReject
        },
        model: {
            prop: 'toggled',
            event: 'toggle'
        },
        props: {
            toggled: {
                type: Boolean,
                required: true
            },
            application: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_form_modal: this.toggled,
                show_success_modal: false,
                form: {
                    rejected_reason: 'property-let'
                }
            }
        },
        watch: {
            toggled () {
                this.show_form_modal = this.toggled
            }
        },
        methods: {
            closeAll () {
                this.show_success_modal = false
                this.show_form_modal = false

                this.$emit('toggle', false)
            },
            onSuccess () {
                this.show_form_modal = false
                this.show_success_modal = true
            }
        }
    }
</script>
